import React from "react"
import { isMobile } from "react-device-detect";
import './SuccessfulLogin.scss'
import NewFillButton from "../Core/NewFillButton";
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';


export const SuccessfulLogin = props =>{
    return (
        <div className={` flex col items-center full-height max-w-370 padding-right-basic padding-left-basic ${isMobile && 'content-center space-between'}`}>
            <div className={`${isMobile && 'padding-top-basic'}`}>
                <div className="gap-32 flex col ">
                    <div className="title">
                        Check your email
                    </div>
                    <div className="sub-title">
                        We've sent a link to your email. Click the link in the email to log in. If you don't see the email, check your spam folder or click below to resend the magic link.
                    </div>
                </div>
                <div className='width-full padding-top-basic'>
                    <NewFillButton onClick={() => props.onResend()}>Resend link</NewFillButton>
                </div>
            </div>
            <div className="back-btn items-center flex padding-bottom-basic" onClick={()=> props.onBack()}>
                <KeyboardBackspaceIcon/>
                back to log in
            </div>
        </div>
    )
}